import Slider from './Slider';
import SliderProvider, { useSliderContext } from './Slider.provider';

export { SliderProvider, useSliderContext };
export default Slider;
